import { render, staticRenderFns } from "./IndexPopupEdit.vue?vue&type=template&id=8c4f4f8e"
import script from "./IndexPopupEdit.vue?vue&type=script&lang=js"
export * from "./IndexPopupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports